import { render, staticRenderFns } from "./AnnouncementBarList.vue?vue&type=template&id=5f7bcd5a"
import script from "./AnnouncementBarList.vue?vue&type=script&lang=js"
export * from "./AnnouncementBarList.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBarList.vue?vue&type=style&index=0&id=5f7bcd5a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports